module.exports = __webpack_public_path__ + "img/Fort McPherson Station Concepts_Page_1.850f81b3.jpg";